var utils = require("../utils");

var CustomDateFieldWithExtendedTag = function (config) {
  jsGrid.Field.call(this, config);
};

CustomDateFieldWithExtendedTag.prototype = new jsGrid.Field({
  css: "date-dclg", // redefine general property 'css'

  itemTemplate: function (value, item) {
    var tagCss = this._grid.tagCss
    if(value.extended) {
      return utils.cleanDate(value.date) + " " + getExtendedTemplate("Extended")[0].outerHTML;
    }
    else{
      return String(utils.cleanDate(value.date));
    }

    function getExtendedTemplate (value)
    {
      var $link = $("<strong>")
        .addClass(getCss(value))
        .text(value);
      return $link;
    }
    function getCss (value) {
      if (tagCss) {
        return tagCss[value.trim().toLowerCase()]
      }
      return ''
    }
  }
});

module.exports = CustomDateFieldWithExtendedTag;